export default defineNuxtPlugin(async () => {
    const {
        cmsStore,
        authStore,
        activitiesRuntimeStore,
        runtimeStore,
        hotelsStore,
        hotelsRuntimeStore,
        flightsRuntimeStore,
        carsRentRuntimeStore,
        packagesRuntimeStore,
        cruisesRuntimeStore,
        toursRuntimeStore,
        transfersRuntimeStore,
        insuranceRuntimeStore,
        visaRuntimeStore,
        supplierStore,
        extraServicesRuntimeStore,
        simpleTourRuntimeStore,

        persistentStore,
        transfersStore,
        activitiesStore,
        flightsStore,
        packagesStore,
        toursStore,
        extraServicesStore,
        carsRentStore,
        insuranceStore,
        visaStore,
        cruisesStore,
        simpleTourStore,
    } = initialiseStores()

    if (import.meta.client) {
        runtimeStore.clientInit()
        cmsStore.clientInit()
        hotelsRuntimeStore.clientInit()
        flightsRuntimeStore.clientInit()
        activitiesRuntimeStore.clientInit()
        carsRentRuntimeStore.clientInit()
        cruisesRuntimeStore.clientInit()
        packagesRuntimeStore.clientInit()
        toursRuntimeStore.clientInit()
        transfersRuntimeStore.clientInit()
        extraServicesRuntimeStore.clientInit()
        insuranceRuntimeStore.clientInit()
        visaRuntimeStore.clientInit()
        supplierStore.clientInit()
        simpleTourRuntimeStore.clientInit()
        return {
            provide: {
                store: {
                    restored: Promise.all([
                        hotelsStore.$persistedState.isReady(),
                        persistentStore.$persistedState.isReady(),
                        transfersStore.$persistedState.isReady(),
                        activitiesStore.$persistedState.isReady(),
                        flightsStore.$persistedState.isReady(),
                        packagesStore.$persistedState.isReady(),
                        toursStore.$persistedState.isReady(),
                        extraServicesStore.$persistedState.isReady(),
                        carsRentStore.$persistedState.isReady(),
                        insuranceStore.$persistedState.isReady(),
                        visaStore.$persistedState.isReady(),
                        cruisesStore.$persistedState.isReady(),
                        simpleTourStore.$persistedState.isReady(),
                    ]),
                },
            },
        }
    } else {
        hotelsStore.serverInit()
        await authStore.serverInit()
        await Promise.all([runtimeStore.serverInit(), cmsStore.serverInit()])
    }
})
